export default {
	isEmpty (state) {
		return !state.list.length
	}
}
